<template>
	<div class="Foot">
		<div class="content">
			<el-row>
				<el-col :span="16" class="ls2 hidden-xs-only">
					<el-row>
						<el-col :span="4">
							<div class="Foot_title">关于我们</div>
							<div class="Foot_item" @click="link('GSJJ')">公司简介</div>
							<div class="Foot_item" @click="link('FZLC')">发展历程</div>
							<div class="Foot_item" @click="link('YWBK')">业务板块</div>
							<div class="Foot_item" @click="link('ZZJG')">组织机构</div>
							<div class="Foot_item" @click="link('FWLN')">服务理念</div>
							<div class="Foot_item" @click="link('ZZRY')">资质荣誉</div>
							<div class="Foot_item" @click="link('QYYS')">企业优势</div>
						</el-col>
						<el-col :span="4">
							<div class="Foot_title">公司动态</div>
							<div class="Foot_item" @click="link('News')">公司动态</div>
						</el-col>
						<el-col :span="4">
							<div class="Foot_title">合作案例</div>
							<div class="Foot_item" @click="link('Case')">经典案例</div>
							<div class="Foot_item" @click="link('Case', 'hz')">合作伙伴</div>
						</el-col>
						<el-col :span="4">
							<div class="Foot_title">服务流程</div>
							<div class="Foot_item" @click="link('Service')">服务流程</div>
						</el-col>
						<el-col :span="4">
							<div class="Foot_title">联系我们</div>
							<div class="Foot_item" @click="link('Us')">联系方式</div>
							<div class="Foot_item" @click="link('Us', 'ly')">在线留言</div>
						</el-col>
						<el-col :span="4">
							<div class="Foot_title">业务功能</div>
							<div class="Foot_item" @click="link('WLGHZX')">物流规划咨询</div>
							<div class="Foot_item" @click="link('ZNZBZZYJC')">智能装备制造与集成</div>
							<div class="Foot_item" @click="link('ZHWLRJKF')">智慧物流软件开发</div>
							<div class="Foot_item" @click="link('GYLFW')">供应链服务</div>
						</el-col>
					</el-row>
					<div class="Foot_title" style="margin: 40px 0 10px 0;">友情链接</div>
					<a href="http://www.yuxin-robots.com/Html/index.html" target="_blank" class="Foot_item now" style="font-size: 14px;">杭州裕新智能科技有限公司</a>
					<span class="plr30 ff">|</span>
					<!-- <a href="http://www.ccxinzhou.com/Html/Index.html" target="_blank" class="Foot_item now" style="font-size: 14px;">吉林省新舟智能科技有限公司</a>
					<span class="plr30 ff">|</span> -->
					<a :href="$store.state.btz.url" target="_blank" class="Foot_item now" style="font-size: 14px;">{{$store.state.btz.name}}</a>
				</el-col>
				<el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
					<div class="tr footer" style="letter-spacing: 0!important;">
						<span class="Foot_item nohover">热线电话：</span>
						<a class="blue3 hidden-xs-only">{{state.tel}}</a>
						<a class="blue3 show-xs-only" :href="'tel:'+state.tel">{{state.tel}}</a>
						<div class="Foot_item nohover mb10 mt5">{{state.address}}</div>
						<a class="blue3 hidden-xs-only">{{state.e_mail}}</a>
						<a class="blue3 show-xs-only" :href="'mailto:'+state.e_mail">{{state.e_mail}}</a>
					</div>
					<div class="fr tz mt35 hidden-xs-only">
						<img src="../../assets/QR.png" />
						<div class="Foot_item mt10 nohover" style="font-size: 14px;">微信公众号</div>
					</div>
					<div class="cl"></div>
				</el-col>
			</el-row>
		</div>
		<div class="Power">
			<!-- <span>ICP备案编号：吉ICP备17007846号-1</span> -->
			<span onclick="window.open('https://beian.miit.gov.cn')" class="cp" style="text-decoration: underline;">ICP备案编号：吉ICP备20002713号-1</span>
			<span class="mlr30"></span>
			<span onclick="window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=22017302000255')" class="cp" style="text-decoration: underline;">
				<img src="../../assets/gongan.png" />
				公安部备案号：22017302000255
			</span>
			<span class="mlr30"></span>
			<span>©{{state.name}} 版权所有</span>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: ''
			}
		},
		computed: {
			state() {
				return this.$store.state
			}
		},
		watch: {
			'$store.state.link'() {
				this.$nextTick(() => {  //页面加载完成后执行
					if (this.id) {
						document.getElementById(this.id).scrollIntoView();
						this.id = '';
					}
				})
			}
		},
		methods: {
			link(name, id) {
				this.id = id || null;
				this.$router.push({
					name: name
				});
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			}
		}
	}
</script>

<style lang="scss">
	.Foot {
		background: url(../../assets/Foot.png) no-repeat left center;
		background-size: cover;
		padding-top: 70px;

		.Foot_title {
			color: #FFFFFF;
			font-size: 16px;
			margin-bottom: 35px;
			font-weight: bold;
			cursor: default;
		}

		.Foot_item {
			font-size: 16px;
			color: #c7c7c7;
			line-height: 2;
			cursor: pointer;
			transition: all 0.3s;
			-webkit-transition: all 0.3s;

			&:hover {
				color: #FFFFFF;
			}
			
			&.nohover {
				cursor: default;
				&:hover {
					color: #c7c7c7;
				}
			}
			@media screen and (max-width: 768px) {
				margin: 0;
			}
		}
		
		.Power {
			padding: 25px 0;
			border-top: 1px solid #514e59;
			text-align: center;
			margin-top: 40px;
			
			span {
				font-size: 15px;
				color: #888787;
			}
		}
		
		a {
			text-decoration: none;
		}

    @media screen and (max-width: 1200px) {
      .plr30 {
	      padding: 0 10px;
      }
    }
		
		@media screen and (max-width: 768px) {
			padding-top: 40px;
			
			.content {
				.tr {
					text-align: center;
				}
			}
			.Power {
				span{
					display: inline-block;
					width: 100%;
					text-align: center;
					font-size: 12px;
					margin: 6px 0;
				}
				.mlr30 {
					display: none;
				}
			}
			
			.footer {
				line-height: 1.5;
			}
		}
	}
</style>
